<div class="adminScreen backdrop">


  <div class="centeredArea">


    <div class="adminPassControl" *ngIf="isPasswordNotEntered">
      <numericKeyboard
        [password]="true"
        (onEntered)="passwordCheck($event)"
        [inputSize]="1">
      </numericKeyboard>
    </div>



    <div  *ngIf="!isPasswordNotEntered" class="headAdmin">
      Yönetim Paneli
    </div>
    <div  *ngIf="!isPasswordNotEntered" class="mainContainer">
      <div class="leftArea">
        <div class="menuItemContainer" *ngFor="let menuItem of menuData">
          <p class="menuItemBig {{selectedItem.b === menuItem.id ? 'active': ''}}"
             (click)="onMenuItemClick( menuItem.id, menuItem.subMenus[0].id)">{{menuItem.text}}</p>
          <div class="smallSubMenu {{selectedItem.b === menuItem.id ? 'isVisible' : '' }}"
               *ngFor="let subMenuItem of menuItem.subMenus">
            <p class="menuItemSmall {{selectedItem.s === subMenuItem.id ? 'active': ''}}"
               (click)="onMenuItemClick( menuItem.id, subMenuItem.id)">{{subMenuItem.text}}</p>
          </div>


        </div>


      </div>
      <div class="rightArea">


        <div class="adminScreenItem" *ngIf="selectedItem.b  === 'non'">
          <div class="dialogScreen">
            <p>Soldaki menüden seçim yapınız.</p>
          </div>
        </div>


        <div class="adminScreenItem" *ngIf="selectedItem.s  === 'parac'">
          <p>Otomatta güncel olarak bulunan para miktarı</p>
          <div class="dialogScreen">
            <p>{{this.coreService.customerUser?.Balance}}</p>
            <p class="actionButton" (click)="Open_Payout_Modal()" >Para tutarının tamamını tahsil et</p>
          </div>
        </div>

        <div class="adminScreenItem" *ngIf="selectedItem.s  === 'grapor'">
          <p>Şunun için rapor yazdır</p>
          <div class="dialogScreen">

            <div class="horizontalButton">
              <p class="actionButton">BUGÜN</p>
              <p class="actionButton">DÜN</p>
            </div>
          </div>
          <div class="dialogScreen">

            <input type="hidden" name="mydate" angular-mydatepicker
                   [(ngModel)]="dateModel_daily" [options]="myDpOptions"
                   (dateChanged)="onDateChanged($event)"
                   [locale]="langCode"
            />

            <p>{{dateModel_daily && dateModel_daily['singleDate'] && dateModel_daily['singleDate']['jsDate'] | date : 'fullDate' }}</p>
            <p class="actionButton">Yazdır</p>

          </div>


        </div>

        <div class="adminScreenItem" *ngIf="selectedItem.s  === 'arapor'">
          <p>Şunun için rapor yazdır</p>
          <div class="dialogScreen">

            <div class="horizontalButton">
              <p class="actionButton">BU AY</p>
              <p class="actionButton">ÖNCEKİ AY</p>
            </div>
          </div>
          <div class="dialogScreen">
            <input type="hidden" name="mydate" angular-mydatepicker
                   *ngIf="dateModel_monthly_Select"
                   [(ngModel)]="dateModel_monthly" [options]="myDpOptions"
                   (dateChanged)="onDateChanged($event)"
                   [locale]="langCode"
                   (calendarViewChanged)="onCalendarView($event)"
            />

            <p *ngIf="!dateModel_monthly_Select">Seçim: {{dateModel_monthly_MY | date : 'yyyy, MMMM'}}</p>
            <p *ngIf="!dateModel_monthly_Select"
               class="actionButton"
               (click)="onChangeSelectStatsMonth()">Tekrar Seç</p>

            <p class="actionButton">Yazdır</p>

          </div>


        </div>


        <div class="adminScreenItem" *ngIf="selectedItem.s  === 'bkupon'">
          <div class="errorShowMsg" *ngIf="bkupon_error != '' ">{{bkupon_error}}</div>
          <p>Bahis kuponu numarasını giriniz.</p>
          <div class="dialogScreen">
            <numericKeyboard
              [inputSize]=2
              (onEntered)="onPayoutSlipPay($event[0],$event[1])"
            >
            </numericKeyboard>

            <p class="actionButton">Yazdır</p>

          </div>


        </div>

        <div class="adminScreenItem" *ngIf="selectedItem.s  === 'bkuponu'">
          <div class="errorShowMsg" *ngIf="bkuponu_error != ''">{{bkuponu_error}}</div>
          <p>Bahis kuponu numarasını giriniz.</p>

          <div class="dialogScreen">

            <div class="horizontalButton">
              <p class="actionButton" (click)="PrintLastSlip()" >SON KUPONU YAZDIR</p>
            </div>
          </div>

          <div class="dialogScreen">
            <numericKeyboard
              [inputSize]=2
              (onEntered)="getPrintLastSlipByParameter($event)"
            >
            </numericKeyboard>

            <p class="actionButton" (click)="getPrintLastSlipByParameter()" >Yazdır</p>

          </div>


        </div>


      </div>
    </div>
  </div>


</div>
